import { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge.jsx';
import { listBlockedMarkets } from '@/services/markets.service.js';

// MV-02 2.3 (Ship 2 item 4): the blocked-market registry, account level.
// Who holds this account at which market, until when. MV-09's renewal
// clearing play reads the same registry. Self-hides when nothing is blocked.
export default function BlockedMarketsCard({ accountId, refreshKey }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (!accountId) return;
    let dead = false;
    listBlockedMarkets(accountId)
      .then((d) => { if (!dead) setRows(d.blocked || []); })
      .catch(() => { if (!dead) setRows(null); });
    return () => { dead = true; };
  }, [accountId, refreshKey]);

  if (!rows || rows.length === 0) return null;

  return (
    <div className="rounded-card border border-border bg-surface px-3.5 py-3">
      <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.08em] text-text-dim">
        Blocked markets
      </p>
      {rows.map((r) => (
        <div key={r.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-border/60 py-2 text-sm last:border-b-0">
          <span className="min-w-0 flex-1 truncate font-medium text-text">{r.carrier_name || 'Ad-hoc market'}</span>
          <span className="text-xs text-text-muted">
            held by {r.blocked_by || 'unknown'}
            {r.blocked_until ? ` until ${r.blocked_until}` : ' (no end date)'}
          </span>
          <Badge variant={r.active ? 'warning' : 'muted'}>{r.active ? 'Active block' : 'Expired'}</Badge>
        </div>
      ))}
      <p className="mt-1.5 text-[11px] text-text-dim">
        Active blocks are excluded from market suggestions for this account.
      </p>
    </div>
  );
}
